import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from './ApiConfig';

const PromoImageSlider = () => {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch images from API
  useEffect(() => {
    const fetchImages = async () => {
      try {
     const response = await axios.get(`${API_BASE_URL}/api/promo-images?premifeast=1`);
        const activeImages = response.data.filter((img) => img.stage);
        setImages(activeImages);
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };
    fetchImages();
  }, []);

  // Auto-slide functionality
  useEffect(() => {
    if (images.length <= 1) return; // No auto-slide for 0 or 1 image

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 5000); // Slide every 5 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [images]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  if (images.length === 0) {
    return <div style={{ textAlign: 'center', color: '#6b7280', fontFamily: "'Bangers', sans-serif" }}>No active promo images</div>;
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        margin: '0 auto',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          width: `${images.length * 100}%`,
          transform: `translateX(-${currentIndex * (100 / images.length)}%)`,
          transition: 'transform 0.5s ease-in-out',
        }}
      >
        {images.map((image, index) => (
          <img
            key={index}
            id={`prp_img_${index}`}
            src={`data:image/jpeg;base64,${image.image}`}
            alt={`Promo ${index + 1}`}
            style={{
              width: `${100 / images.length}%`,
              height: 'auto',
              objectFit: 'cover',
              borderRadius: '0.5rem',
            }}
          />
        ))}
      </div>
      <button
        onClick={handlePrev}
        style={{
          position: 'absolute',
          left: '1rem',
          top: '50%',
          transform: 'translateY(-50%)',
          background: '#4B2E2E',
          color: 'white',
          width: '3rem',
          height: '3rem',
          fontSize: '1.5rem',
          fontWeight: '700',
          fontFamily: "'Bangers', sans-serif",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '9999px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2)',
          transition: 'all 0.3s ease',
          zIndex: 10,
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'linear-gradient(to right, #4B2E2E, #1C2526)';
          e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#4B2E2E';
          e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2)';
        }}
        aria-label="Previous image"
      >
        ←
      </button>
      <button
        onClick={handleNext}
        style={{
          position: 'absolute',
          right: '1rem',
          top: '50%',
          transform: 'translateY(-50%)',
          background: '#4B2E2E',
          color: 'white',
          width: '3rem',
          height: '3rem',
          fontSize: '1.5rem',
          fontWeight: '700',
          fontFamily: "'Bangers', sans-serif",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '9999px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2)',
          transition: 'all 0.3s ease',
          zIndex: 10,
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'linear-gradient(to left, #4B2E2E, #1C2526)';
          e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#4B2E2E';
          e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2)';
        }}
        aria-label="Next image"
      >
        →
      </button>
      <div
        style={{
          position: 'absolute',
          bottom: '1rem',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '0.5rem',
          zIndex: 10,
        }}
      >
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            style={{
              width: currentIndex === index ? '1.5rem' : '1rem',
              height: '1rem',
              background: currentIndex === index ? '#4B2E2E' : '#1C2526',
              borderRadius: '9999px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#4B2E2E';
              e.currentTarget.style.transform = 'scale(1.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = currentIndex === index ? '#4B2E2E' : '#1C2526';
              e.currentTarget.style.transform = 'scale(1)';
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default PromoImageSlider;